import request from "@/api/request";
export function fetchCityNew() {
    return request({
        url: '/market-service/scrm/company/address',
        method: 'post',
    })
}
export default {
    data() {
        return {
            cityList: [],
        }
    },
    mounted() {
        fetchCityNew().then(res => {
            if (Array.isArray(res)) {
                this.cityList = this.buildTree(Object.freeze(res), null)
            }
        })
    },
    methods: {
        buildTree(list, pid) {
            const tree = [];
            list.forEach((item) => {
                if (item.pid === pid) {
                    let children = this.buildTree(list, item.id);

                    let params = {
                        ...item,
                        key: item.id,
                        value: item.name,
                        label: item.name,
                    }

                    if (children.length > 0) {
                        params.children = children;
                    } else {
                        delete params.children;
                    }

                    tree.push(params);
                }
            });

            return tree;
        }

    }
}